// components/SetNavbar.js
import React, { useEffect, useState } from "react";
import UserNavbar from "../pages/student/components/UserNavbar";
import InstructorNavbar from "../pages/instructor/components/InstructorNavbar";
import PublicNavbar from "./PublicNavbar";

const SetNavbar = ({ scrollToCourses }) => {
  const [userType, setUserType] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initializeUser = () => {
      try {
        const user = localStorage.getItem("user");
        if (!user || user === "null") {
          setUserType(null);
        } else {
          const data = JSON.parse(user);
          setUserType(data?.usertype?.toLowerCase() || null);
        }
      } catch (error) {
        console.error("Error parsing user data:", error);
        setUserType(null);
      } finally {
        setLoading(false);
      }
    };

    initializeUser();
  }, []);

  if (loading) {
    return <div className="navbar-placeholder" />;
  }

  switch (userType) {
    case "instructor":
      return <InstructorNavbar scrollToCourses={scrollToCourses} />;
    case "student":
      return <UserNavbar scrollToCourses={scrollToCourses} />;
    default:
      return <PublicNavbar scrollToCourses={scrollToCourses} />;
  }
};

export default SetNavbar;
